import { Link } from "@tanstack/react-router";
import { cn } from "cn";
import { EXTERNAL_URLS } from "@/constants/external-url";

export default function PublicFooter() {
  return (
    <footer
      className={cn(
        /* sorted */
        "flex flex-wrap items-center justify-center gap-y-2",
        "py-2",
        "md:h-16",
      )}
    >
      <Link
        to={EXTERNAL_URLS.TERMS_OF_SERVICE}
        target="_blank"
        rel="noreferrer"
        className={cn(
          /* sorted */
          "w-1/2",
          "px-2",
          "leading-4 text-right text-sm text-text-dark-high",
          "border-r border-border-dark-low",
          "hover:text-text-primary hover:underline",
          "sm:text-left sm:w-auto",
        )}
      >
        Terms of Service
      </Link>
      <Link
        to={EXTERNAL_URLS.PRIVACY_POLICY}
        target="_blank"
        rel="noreferrer"
        className={cn(
          /* sorted */
          "w-1/2",
          "px-2",
          "leading-4 text-sm text-text-dark-high",
          "border-r border-border-dark-low",
          "hover:text-text-primary hover:underline",
          "sm:text-left sm:w-auto",
        )}
      >
        Privacy Policy
      </Link>
      <Link
        to={EXTERNAL_URLS.COOKIE_POLICY}
        target="_blank"
        rel="noreferrer"
        className={cn(
          /* sorted */
          "w-1/2",
          "px-2",
          "leading-4 text-right text-sm text-text-dark-high",
          "border-r border-border-dark-low",
          "hover:text-text-primary hover:underline",
          "sm:text-left sm:w-auto",
        )}
      >
        Cookie Policy
      </Link>
      <a
        href="mailto:support@birdwatch.com"
        className={cn(
          /* sorted */
          "w-1/2",
          "px-2",
          "leading-4 text-sm text-text-dark-high",
          "border-r border-border-dark-low",
          "hover:text-text-primary hover:underline",
          "sm:text-left sm:w-auto",
        )}
      >
        Contact us
      </a>
      <span
        className={cn(
          /* sorted */
          "w-full",
          "px-2",
          "leading-4 text-center text-sm text-text-dark-high",
          "md:w-auto",
        )}
      >
        © Birdwatch PBC {new Date().getFullYear()}
      </span>
    </footer>
  );
}
